export enum ColumnType {
  String = 0,
  Int = 1,
  Double = 2,
  Decimal = 3,
  DateTime = 4,
  Boolean = 5,
  Enum = 6,
}

export enum UnitType {
  F = 0,
  C = 1,
  Psi = 2,
  KgCm2 = 3,
  bar = 4,
  Psia = 5,
  KgCm2a = 6,
  barA = 7,
  BTUlbF = 8,
  kcalKgC = 9,
  JkgK = 10,
  kW = 11,
  TR = 12,
  Mkcalh = 13,
  HP = 14,
  lbMin = 15,
  kgH = 16,
  lbFt = 17,
  Kgm = 18,
  Nm = 19,
  GPM = 20,
  lm = 21,
  lSec = 22,
  MBH = 23,
  kcalh = 24,
  lb = 25,
  kg = 26,
  inches = 27,
  cm = 28,
  mm = 29,
  cfm = 30,
  m3h = 31,
  K = 32,
  Rankine = 33,
  kpa = 34,
  ms = 35,
  fts = 36,
  Jmol = 37,
  Btu = 38,
  molL = 39,
  LbmFt = 40,
  kgM3 = 41,
  Ft = 42,
  m = 43,
  m3Kg = 44,
  ft3lbm = 45,
  uPa_s = 46,
  lbmFt_s = 47,
  kcalKg = 48,
  BTUlb = 49,
  BTUh = 50,
  DeltaF = 51,
  DeltaC = 52,
  DeltaK = 53,
  c3h = 54,
  i3h = 55,
  kgm2 = 56,
  lbft2 = 57,
  lbft3 = 58,
  Jkg = 59,
  BTUlbR = 60,
  kJkgK = 61,
  kJkg = 62,
  BHP = 63,
  ft2hFBTU = 64,
  m2KW = 65,
  gal = 66,
  l = 67,
  Dn = 68,
  Amp = 69,
  Volt = 70,
  Ohm = 71,
  BtuHrFtF = 72,
  WmK = 73,
  Cp = 74,
  LbFtHr = 75,
  Cv = 76,
  Kv = 77,
  ft3 = 78,
  m3 = 79,
  ftm = 80,
  ft2 = 81,
  m2 = 82,
  GPH = 83,
  Rpm = 84,
  MinNeg1 = 85,
  Psig = 86,
  barG = 87,
  m3s = 88,
}

export const UnitTypeDescriptions = new Map<UnitType, string>([
  [UnitType.F, '°F'],
  [UnitType.C, '°C'],
  [UnitType.Psi, 'psi'],
  [UnitType.KgCm2, 'kg/cm²'],
  [UnitType.bar, 'bar'],
  [UnitType.Psia, 'psia'],
  [UnitType.KgCm2a, 'kg/cm²a'],
  [UnitType.barA, 'bar(a)'],
  [UnitType.BTUlbF, 'BTU/lb °F'],
  [UnitType.kcalKgC, 'kcal/kg °C'],
  [UnitType.JkgK, 'J/kg K'],
  [UnitType.kW, 'kW'],
  [UnitType.TR, 'TR'],
  [UnitType.Mkcalh, 'Mkcal/h'],
  [UnitType.HP, 'HP'],
  [UnitType.lbMin, 'lb/min'],
  [UnitType.kgH, 'kg/h'],
  [UnitType.lbFt, 'lb-ft'],
  [UnitType.Kgm, 'kg-m'],
  [UnitType.Nm, 'Nm'],
  [UnitType.GPM, 'GPM'],
  [UnitType.lm, 'l/min'],
  [UnitType.lSec, 'l/sec'],
  [UnitType.MBH, 'MBH'],
  [UnitType.kcalh, 'kcal/h'],
  [UnitType.lb, 'lb'],
  [UnitType.kg, 'kg'],
  [UnitType.inches, 'in'],
  [UnitType.cm, 'cm'],
  [UnitType.mm, 'mm'],
  [UnitType.cfm, 'ft³/m'],
  [UnitType.m3h, 'm³/h'],
  [UnitType.K, 'K'],
  [UnitType.Rankine, '°R'],
  [UnitType.kpa, 'kPa'],
  [UnitType.ms, 'm/s'],
  [UnitType.fts, 'ft/s'],
  [UnitType.Jmol, 'JMol'],
  [UnitType.Btu, 'BTU'],
  [UnitType.molL, 'molL'],
  [UnitType.LbmFt, 'LbmFt'],
  [UnitType.kgM3, 'kg/m³'],
  [UnitType.Ft, 'Ft'],
  [UnitType.m, 'm'],
  [UnitType.m3Kg, 'm³/kg'],
  [UnitType.ft3lbm, 'ft³/lbm'],
  [UnitType.uPa_s, 'uPa-s'],
  [UnitType.lbmFt_s, 'lbm/ft-s'],
  [UnitType.kcalKg, 'kcal/kg'],
  [UnitType.BTUlb, 'BTU/lb'],
  [UnitType.BTUh, 'BTU/h'],
  [UnitType.DeltaF, '°F'],
  [UnitType.DeltaC, '°C'],
  [UnitType.DeltaK, 'K'],
  [UnitType.c3h, 'cc/h'],
  [UnitType.i3h, 'in³/h'],
  [UnitType.kgm2, 'kg.m²'],
  [UnitType.lbft2, 'lb-ft²'],
  [UnitType.lbft3, 'lb/ft³'],
  [UnitType.Jkg, 'J/kg'],
  [UnitType.BTUlbR, 'BTU/lb °R'],
  [UnitType.kJkgK, 'kJ/kg K'],
  [UnitType.kJkg, 'kJ/kg'],
  [UnitType.BHP, 'BHP'],
  [UnitType.ft2hFBTU, 'ft²hF/BTU'],
  [UnitType.m2KW, 'm²K/W'],
  [UnitType.gal, 'gal'],
  [UnitType.l, 'l'],
  [UnitType.Dn, 'DN'],
  [UnitType.Amp, 'A'],
  [UnitType.Volt, 'V'],
  [UnitType.Ohm, 'Ω'],
  [UnitType.BtuHrFtF, 'BTU/(hr·ft⋅°F)'],
  [UnitType.WmK, 'W/(m·K)'],
  [UnitType.Cp, 'cP'],
  [UnitType.LbFtHr, 'lb/(ft·hr)'],
  [UnitType.Cv, 'Cv'],
  [UnitType.Kv, 'Kv'],
  [UnitType.ft3, 'ft³'],
  [UnitType.m3, 'm³'],
  [UnitType.ftm, 'ft/min'],
  [UnitType.ft2, 'ft²'],
  [UnitType.m2, 'm²'],
  [UnitType.GPH, 'gal/hr'],
  [UnitType.Rpm, 'RPM'],
  [UnitType.MinNeg1, 'minˉ¹'],
  [UnitType.Psig, 'psig'],
  [UnitType.barG, 'bar(g)'],
  [UnitType.m3s, 'm³/sec'],
]);

export enum MeasurementContext {
  Temperature = 0,
  Pressure = 1,
  AbsPressure = 2,
  SpecificHeat = 3,
  Capacity = 4,
  Power = 5,
  MassFlow = 6,
  Torque = 7,
  OilFlow = 8,
  HeatOfRejection = 9,
  Weight = 10,
  Length = 11,
  RefrigerantVolumeFlow = 12,
  Distance = 13,
  Inertia = 14,
  Density = 15,
  LatentHeat = 16,
  SpecificVolume = 17,
  FoulingFactor = 18,
  LiquidVolume = 19,
  ThermalConductivity = 20,
  DynamicViscosity = 21,
  FlowCoefficient = 22,
  Volume = 23,
  Velocity = 24,
  Area = 25,
  LiquidVolumeFlow = 26,
  DeltaTemp = 27,
  InchOrMm = 28,
  BrakePower = 29,
  PipeSize = 30,
  Current = 31,
  Voltage = 32,
  Resistance = 33,
  SeparatorVelocity = 34,
  Speed = 35,
  GaugePressure = 36,
  ElectricalPower = 37
}

export const MeasurementContextDescriptions = new Map<MeasurementContext, string>([
  [MeasurementContext.Temperature, 'Temperature'],
  [MeasurementContext.Pressure, 'Differential Pressure'],
  [MeasurementContext.AbsPressure, 'Absolute Pressure'],
  [MeasurementContext.SpecificHeat, 'Specific Heat'],
  [MeasurementContext.Capacity, 'Capacity'],
  [MeasurementContext.Power, 'Power'],
  [MeasurementContext.MassFlow, 'Mass Flow'],
  [MeasurementContext.Torque, 'Torque'],
  [MeasurementContext.OilFlow, 'Oil Flow'],
  [MeasurementContext.HeatOfRejection, 'Heat of Rejection'],
  [MeasurementContext.Weight, 'Weight'],
  [MeasurementContext.Length, 'Length'],
  [MeasurementContext.RefrigerantVolumeFlow, 'Refrigerant Volume Flow'],
  [MeasurementContext.Distance, 'Distance'],
  [MeasurementContext.Inertia, 'Inertia'],
  [MeasurementContext.Density, 'Density'],
  [MeasurementContext.LatentHeat, 'Latent Heat'],
  [MeasurementContext.SpecificVolume, 'Specific Volume'],
  [MeasurementContext.FoulingFactor, 'Fouling Factor'],
  [MeasurementContext.LiquidVolume, 'Liquid Volume'],
  [MeasurementContext.ThermalConductivity, 'Thermal Conductivity'],
  [MeasurementContext.DynamicViscosity, 'Dynamic Viscosity'],
  [MeasurementContext.FlowCoefficient, 'Flow Coefficient'],
  [MeasurementContext.Volume, 'Volume'],
  [MeasurementContext.Velocity, 'Velocity'],
  [MeasurementContext.Area, 'Area'],
  [MeasurementContext.LiquidVolumeFlow, 'Liquid Volume Flow'],
  [MeasurementContext.DeltaTemp, 'Delta Temp'],
  [MeasurementContext.InchOrMm, 'Inch or mm'],
  [MeasurementContext.BrakePower, 'Brake Power'],
  [MeasurementContext.PipeSize, 'Pipe Size'],
  [MeasurementContext.Current, 'Current'],
  [MeasurementContext.Voltage, 'Voltage'],
  [MeasurementContext.Resistance, 'Resistance'],
  [MeasurementContext.SeparatorVelocity, 'Separator Velocity'],
  [MeasurementContext.Speed, 'Speed'],
  [MeasurementContext.GaugePressure, 'Gauge Pressure'],
  [MeasurementContext.ElectricalPower, 'Electrical Power'],
]);

export const UsUnits = new Map<MeasurementContext, UnitType>([
  [MeasurementContext.Temperature, UnitType.F],
  [MeasurementContext.Pressure, UnitType.Psi],
  [MeasurementContext.AbsPressure, UnitType.Psia],
  [MeasurementContext.SpecificHeat, UnitType.BTUlbF],
  [MeasurementContext.Capacity, UnitType.TR],
  [MeasurementContext.BrakePower, UnitType.BHP],
  [MeasurementContext.Power, UnitType.HP],
  [MeasurementContext.MassFlow, UnitType.lbMin],
  [MeasurementContext.Torque, UnitType.lbFt],
  [MeasurementContext.OilFlow, UnitType.GPM],
  [MeasurementContext.HeatOfRejection, UnitType.MBH],
  [MeasurementContext.Weight, UnitType.lb],
  [MeasurementContext.Length, UnitType.inches],
  [MeasurementContext.RefrigerantVolumeFlow, UnitType.cfm],
  [MeasurementContext.LiquidVolume, UnitType.gal],
  [MeasurementContext.Distance, UnitType.Ft],
  [MeasurementContext.DeltaTemp, UnitType.DeltaF],
  [MeasurementContext.Inertia, UnitType.lbft2],
  [MeasurementContext.Density, UnitType.lbft3],
  [MeasurementContext.LatentHeat, UnitType.BTUlb],
  [MeasurementContext.SpecificVolume, UnitType.ft3lbm],
  [MeasurementContext.FoulingFactor, UnitType.ft2hFBTU],
  [MeasurementContext.InchOrMm, UnitType.inches],
  [MeasurementContext.PipeSize, UnitType.inches],
  [MeasurementContext.Current, UnitType.Amp],
  [MeasurementContext.Resistance, UnitType.Ohm],
  [MeasurementContext.Voltage, UnitType.Volt],
  [MeasurementContext.Velocity, UnitType.fts],
  [MeasurementContext.ThermalConductivity, UnitType.BtuHrFtF],
  [MeasurementContext.DynamicViscosity, UnitType.LbFtHr],
  [MeasurementContext.FlowCoefficient, UnitType.Cv],
  [MeasurementContext.Volume, UnitType.ft3],
  [MeasurementContext.Area, UnitType.ft2],
  [MeasurementContext.SeparatorVelocity, UnitType.ftm],
  [MeasurementContext.Speed, UnitType.Rpm],
  [MeasurementContext.GaugePressure, UnitType.Psig],
  [MeasurementContext.LiquidVolumeFlow, UnitType.GPM],
  [MeasurementContext.ElectricalPower, UnitType.kW]
]);

export const SiUnits = new Map<MeasurementContext, UnitType>([
  [MeasurementContext.Temperature, UnitType.C],
  [MeasurementContext.Pressure, UnitType.bar],
  [MeasurementContext.AbsPressure, UnitType.barA],
  [MeasurementContext.SpecificHeat, UnitType.kJkgK],
  [MeasurementContext.Capacity, UnitType.kW],
  [MeasurementContext.BrakePower, UnitType.kW],
  [MeasurementContext.Power, UnitType.kW],
  [MeasurementContext.MassFlow, UnitType.kgH],
  [MeasurementContext.Torque, UnitType.Nm],
  [MeasurementContext.OilFlow, UnitType.lm],
  [MeasurementContext.HeatOfRejection, UnitType.kW],
  [MeasurementContext.Weight, UnitType.kg],
  [MeasurementContext.Length, UnitType.cm],
  [MeasurementContext.RefrigerantVolumeFlow, UnitType.m3h],
  [MeasurementContext.LiquidVolume, UnitType.l],
  [MeasurementContext.Distance, UnitType.m],
  [MeasurementContext.DeltaTemp, UnitType.DeltaK],
  [MeasurementContext.Inertia, UnitType.kgm2],
  [MeasurementContext.Density, UnitType.kgM3],
  [MeasurementContext.LatentHeat, UnitType.kJkg],
  [MeasurementContext.SpecificVolume, UnitType.m3Kg],
  [MeasurementContext.FoulingFactor, UnitType.m2KW],
  [MeasurementContext.InchOrMm, UnitType.mm],
  [MeasurementContext.PipeSize, UnitType.Dn],
  [MeasurementContext.Current, UnitType.Amp],
  [MeasurementContext.Resistance, UnitType.Ohm],
  [MeasurementContext.Voltage, UnitType.Volt],
  [MeasurementContext.Velocity, UnitType.ms],
  [MeasurementContext.ThermalConductivity, UnitType.WmK],
  [MeasurementContext.DynamicViscosity, UnitType.Cp],
  [MeasurementContext.FlowCoefficient, UnitType.Kv],
  [MeasurementContext.Volume, UnitType.m3],
  [MeasurementContext.Area, UnitType.m2],
  [MeasurementContext.SeparatorVelocity, UnitType.ms],
  [MeasurementContext.Speed, UnitType.MinNeg1],
  [MeasurementContext.GaugePressure, UnitType.barG],
  [MeasurementContext.LiquidVolumeFlow, UnitType.m3h],
  [MeasurementContext.ElectricalPower, UnitType.kW]
]);

export class Measurement {
  Value: number = 0;
  Unit: UnitType = UnitType.F;
}